exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".Navigator_navigator__Zgj11 {\n  flex: 1 1;\n  display: flex;\n  flex-direction: column;\n  min-height: 0; }\n  .Navigator_navigator__Zgj11 .Navigator_search_bar_container__3uYdo {\n    height: 32px;\n    padding: 0 8px;\n    display: flex;\n    align-items: stretch;\n    border-bottom: 1px solid #505050; }\n    .Navigator_navigator__Zgj11 .Navigator_search_bar_container__3uYdo:focus-within {\n      background-color: rgba(255, 255, 255, 0.1); }\n    .Navigator_navigator__Zgj11 .Navigator_search_bar_container__3uYdo .Navigator_search_icon__339_Z {\n      align-self: center;\n      margin-right: 8px; }\n    .Navigator_navigator__Zgj11 .Navigator_search_bar_container__3uYdo .Navigator_search_bar__1y5UI {\n      flex: 1 1;\n      box-sizing: border-box; }\n  .Navigator_navigator__Zgj11 .Navigator_algorithm_list__1ekbw {\n    flex: 1 1;\n    overflow-y: auto; }\n  .Navigator_navigator__Zgj11 .Navigator_footer__3pC2E {\n    max-height: 30vh;\n    border-top: 1px solid #505050;\n    overflow-y: auto; }\n", ""]);

// Exports
exports.locals = {
	"themeDark": "#242424",
	"themeNormal": "#393939",
	"themeLight": "#505050",
	"colorFont": "#bbbbbb",
	"colorShadow": "rgba(0, 0, 0, 0.2)",
	"colorOverlay": "rgba(255, 255, 255, 0.1)",
	"colorAlert": "#f3bd58",
	"colorSelected": "#2962ff",
	"colorPatched": "#c51162",
	"colorHighlight": "#29d",
	"colorActive": "#00e676",
	"lineHeight": "32px",
	"fontSizeNormal": "12px",
	"fontSizeLarge": "14px",
	"navigator": "Navigator_navigator__Zgj11",
	"search_bar_container": "Navigator_search_bar_container__3uYdo",
	"search_icon": "Navigator_search_icon__339_Z",
	"search_bar": "Navigator_search_bar__1y5UI",
	"algorithm_list": "Navigator_algorithm_list__1ekbw",
	"footer": "Navigator_footer__3pC2E"
};